import {Module, Component} from '../decorators';

import tpl from './state.picker.html';


@Module({
    name: "app.directives.state.component",
})
@Component({
    selector: 'blnd-state-picker',
    template: tpl,
    bindings: {
        ngModel: '=',
        mode: '@',
        inputClass: '@',
    },
})
export default class C {
    constructor (Config) {
        "ngInject";
        this.states = Config.$config.states;
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/state.picker.js